module.exports = __webpack_public_path__ + "static/img/banner3-joinus.4180aab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner3-joinus.jpg
// module id = AZTV
// module chunks = 1